export const dateConfig = {
  dateString: 'YYYY-MM-DD',
  timeString: 'HH:mm:ss',
  dateTimeString: 'YYYY-MM-DDTHH:mm:ss',
  dateFormat: VARS.DATE_FORMAT,
  timeFormat: 'HH:mm A',
};

export const configAppInstance = {
  client: 'fastcover',
};

export const appConfig = {
  // eslint-disable-next-line no-undef
  privacyStatementUrl: VARS.PRIVACY_STATEMENTURL,
  fontType: VARS.FONT_TYPE,
  showFraudNotice: VARS.SHOW_FRAUD_NOTICE,
  showPaymentVia: VARS.SHOW_PAYMENT_VIA,
  showANZPayment: VARS.FNOL_ANZ,
  reactAppEnv: VARS.REACT_APP_ENV,
  customerPortal: (VARS.MESSAGE && VARS.MESSAGE.authPortalLink) ? VARS.MESSAGE.authPortalLink : null,
  fnolYourAttachments: VARS.FNOL_YOUR_ATTACHMENTS,
};



// WEBPACK FOOTER //
// ./app/configureApp.js